/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Message/view.blocks to change it.
import "DesignSystem/Fonts/Inter-300.css"
import React from 'react'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Message({
  children,
  viewPath = "/DesignSystem/Message",
  text = "",
  color = "#404040",
  fontSize = 18,
  fontWeight = 300,
  lineHeight = 1.2,
  marginBottom = 0,
  marginTop = 4
  
}) {
  return (<React.Fragment
>
<span
  data-testid="Message.Text"
  data-view-path={viewPath}
 style={{'--c-1-Z1Y0bkF': color,'--fs-2-Z1Y0bkF': typeof fontSize === 'number' ? `${fontSize}px` : fontSize,'--fw-3-Z1Y0bkF': fontWeight,'--lh-4-Z1Y0bkF': lineHeight,'--mb-5-Z1Y0bkF': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--mt-6-Z1Y0bkF': typeof marginTop === 'number' ? `${marginTop}px` : marginTop}}
 className={`views-text ${styles.Text}`}
>
{text}
</span>
{children}
</React.Fragment>)
}